import { Modal, notification } from "antd"
import { Company, CompanyService } from "uai-graos-sdk"
import AuthService from "../../services/Auth.Service"
import { useEffect, useState } from "react"
import { ExclamationCircleFilled } from '@ant-design/icons'
import { useNavigate } from "react-router-dom"

export const useCompany = () => {
    const accountId = AuthService.getAccount()
    const { confirm } = Modal

    const navigation = useNavigate()

    const [accounts, setAccounts] = useState<Company.Page>()
    const [pagination, setPagination] = useState<Company.Query>({
        page: 0,
        size: 10,
        merchantResponsibleId: accountId!
    })
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        getPreRegisters(pagination)
    }, [pagination])

    const createPreRegister = async (body: Company.Input) => {
        const accountId = AuthService.getAccount()
        setIsLoading(true)
        await CompanyService.createPreRegister(accountId!, body)
            .then(() => {
                notification.success(
                    {
                        message: 'Sucesso!',
                        description: 'O pré-cadastro foi concluido!'
                    }
                )
            })
        setIsLoading(false)
    }

    const getPreRegisters = async (query: Company.Query) => {
        setIsLoading(true)
        await CompanyService.getAllPreRegisters(query)
            .then((resp: Company.Page) => {
                setAccounts(resp)
            })
        setIsLoading(false)
        }

         const handlePaginationChange = (
            page: number,
            pageSize: number,
        
        ) => {
            setPagination((prevPagination) => ({
                ...prevPagination,
                page: page - 1,
                current: page - 1,
                size: pageSize
            }))       
        }
        

        const createAccountByCompany = async (companyId:string, record: Company.Company) => {
            confirm({
                title: 'Atenção!',
                icon: <ExclamationCircleFilled />,
                content: `Você deseja mesmo transformar o pré-cadastro de ${record.name} em um usuário?`,
                okText: 'Sim',
                cancelText: 'Não',
                onOk: async () =>  {
                   await CompanyService.createAccountByCompany(companyId)
                   .then(() => {
                    notification.success(
                        {
                            message: 'Sucesso!',
                            description: 'O cadastro foi concluído!'
                        }
                    )
                    navigation('/clients')
                   })
                },
                onCancel() { },
            });

        }


        
    return { createPreRegister, accounts, getPreRegisters, pagination, handlePaginationChange, isLoading, createAccountByCompany }

}